// extracted by mini-css-extract-plugin
export default {"table-cell":"TableCell_table-cell__1fAh3","single-line":"TableCell_single-line__2GDG4","multi-line":"TableCell_multi-line__2oAxU"};